import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  height: 300px;
  width: 100%;
  background-image: url(${props => props.url || '/modal.jpg'});
  background-size: cover;
  background-position: center;
`

export default (props) => (
  <Container {...props}  />
)
